<ng-template #defaultTemplate let-item>{{ item }}</ng-template>

<div class="row">
  <div class="col-12 col-lg-5">
    <mat-card class="mb-3">
      <div class="px-3">
        <div class="mb-2">
          <small>A Selecionar</small>
        </div>

        <!-- Pesquisa -->
        @if (getAllItems(false).length > 0) {
          <div
            class="d-flex align-items-center justify-content-between"
            style="column-gap: 24px"
          >
            <!-- Inverter seleção -->
            <i
              (click)="invertCheck(false)"
              matTooltip="Inverter Seleção"
              style="
                margin-top: -18px !important;
                font-size: 18px;
                cursor: pointer;
              "
              [class]="
                invertNotSelectedChecked
                  ? 'fas fa-check-square text-secondary'
                  : 'far fa-square text-muted'
              "
            ></i>
            <mat-form-field
              appearance="outline"
              class="w-100"
              style="font-size: 13px"
            >
              <mat-label>Pesquisar</mat-label>
              <input
                matInput
                #notSelectedSearch
                type="search"
                placeholder="Digite o termo a ser pesquisado..."
                (input)="filter($event, false)"
                [disabled]="disabled"
              />
            </mat-form-field>
          </div>
        }

        <mat-divider></mat-divider>
      </div>

      <div
        class="mt-3 d-flex align-items-center justify-content-center"
        [ngStyle]="{
          height: getAllItems(false).length == 0 ? '41dvh' : '33dvh',
        }"
        style="overflow-x: hidden; overflow-y: auto"
      >
        @if (getFilteredItems(false).length == 0) {
          <up-not-found> </up-not-found>
        }

        @if (getFilteredItems(false).length > 0) {
          <mat-action-list class="h-100 w-100">
            @for (
              item of getFilteredItems(false);
              track item;
              let iAll = $index
            ) {
              <button
                type="button"
                mat-list-item
                style="height: auto; width: 100%"
                (click)="check(item)"
                [disabled]="disabled"
              >
                <div style="display: flex; align-items: center">
                  <div style="width: 32px; text-align: left">
                    <i
                      class="fa-lg"
                      [class]="
                        item.checked
                          ? 'fas fa-check-square text-secondary'
                          : 'far fa-square text-muted'
                      "
                    ></i>
                  </div>
                  <ng-container
                    [ngTemplateOutlet]="itemTemplate || defaultTemplate"
                    [ngTemplateOutletContext]="{ $implicit: item, index: iAll }"
                  >
                  </ng-container>
                </div>
              </button>
            }
          </mat-action-list>
        }
      </div>
    </mat-card>
  </div>

  <!-- Buttons Xs -->
  <div
    class="col-12 col-lg-2 d-flex d-lg-none justify-content-around align-items-center mb-3"
  >
    <div>
      <button
        type="button"
        mat-flat-button
        color="primary"
        matTooltip="Adicionar à seleção"
        (click)="addChecked()"
        [disabled]="disabled"
        class="me-2"
      >
        <i class="fas fa-chevron-down"></i>
      </button>
      <div class="mt-1 d-block d-sm-none"></div>
      <button
        type="button"
        mat-flat-button
        color="primary"
        matTooltip="Remover da seleção"
        (click)="removeChecked()"
        [disabled]="disabled"
      >
        <i class="fas fa-chevron-up"></i>
      </button>
    </div>

    <div>
      <button
        type="button"
        mat-flat-button
        color="primary"
        matTooltip="Adicionar todos à seleção"
        (click)="addAll()"
        [disabled]="disabled"
        class="me-2"
      >
        <i class="fas fa-chevron-double-down"></i>
      </button>
      <div class="mt-1 d-block d-sm-none"></div>
      <button
        type="button"
        mat-flat-button
        color="primary"
        matTooltip="Remover todos da seleção"
        (click)="removeAll()"
        [disabled]="disabled"
      >
        <i class="fas fa-chevron-double-up"></i>
      </button>
    </div>
  </div>

  <!-- Buttons Lg -->
  <div
    class="col-12 col-lg-2 d-none d-lg-flex align-items-center justify-content-center"
    style="height: 48dvh"
  >
    <div class="d-flex flex-column" style="gap: 16px">
      <button
        type="button"
        mat-flat-button
        color="primary"
        matTooltip="Adicionar à seleção"
        matTooltipPosition="above"
        (click)="addChecked()"
        [disabled]="disabled"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
      <button
        type="button"
        mat-flat-button
        color="primary"
        matTooltip="Remover da seleção"
        (click)="removeChecked()"
        [disabled]="disabled"
      >
        <i class="fas fa-chevron-left"></i>
      </button>

      <button
        type="button"
        mat-flat-button
        color="primary"
        matTooltip="Adicionar todos à seleção"
        matTooltipPosition="above"
        (click)="addAll()"
        [disabled]="disabled"
        class="mt-5"
      >
        <i class="fas fa-chevron-double-right"></i>
      </button>
      <button
        type="button"
        mat-flat-button
        color="primary"
        matTooltip="Remover todos da seleção"
        (click)="removeAll()"
        [disabled]="disabled"
      >
        <i class="fas fa-chevron-double-left"></i>
      </button>
    </div>
  </div>

  <div class="col-12 col-lg-5">
    <mat-card class="mb-3">
      <div class="px-3">
        <div class="mb-2">
          <small
            [class]="
              required && getAllItems(true).length == 0
                ? 'text-danger'
                : 'text-primary'
            "
            >Seleção Atual
            @if (required) {
              <span>*</span>
            }
          </small>
        </div>

        <!-- Pesquisa -->
        @if (getAllItems(true).length > 0) {
          <div
            class="d-flex align-items-center justify-content-between"
            style="column-gap: 24px"
          >
            <!-- Inverter seleção -->
            <i
              (click)="invertCheck(true)"
              matTooltip="Inverter Seleção"
              style="
                margin-top: -18px !important;
                font-size: 18px;
                cursor: pointer;
              "
              [class]="
                invertSelectedChecked
                  ? 'fas fa-check-square text-secondary'
                  : 'far fa-square text-muted'
              "
            ></i>
            <mat-form-field
              appearance="outline"
              class="w-100"
              style="font-size: 13px"
            >
              <mat-label>Pesquisar</mat-label>
              <input
                matInput
                #selectedSearch
                type="search"
                placeholder="Digite o termo a ser pesquisado..."
                (input)="filter($event, true)"
                [disabled]="disabled"
              />
            </mat-form-field>
          </div>
        }

        <mat-divider></mat-divider>
      </div>

      <div
        class="mt-3 d-flex align-items-center justify-content-center"
        [ngStyle]="{
          height: getAllItems(true).length == 0 ? '41dvh' : '33dvh',
        }"
        style="overflow-x: hidden; overflow-y: auto"
      >
        @if (getFilteredItems(true).length == 0) {
          <up-not-found> </up-not-found>
        }

        @if (getFilteredItems(true).length > 0) {
          <mat-action-list class="h-100 w-100">
            @for (
              item of getFilteredItems(true);
              track item;
              let iAll = $index
            ) {
              <button
                type="button"
                mat-list-item
                style="height: auto; width: 100%"
                (click)="check(item)"
                [disabled]="disabled"
              >
                <div style="display: flex; align-items: center">
                  <div style="width: 32px; text-align: left">
                    <i
                      class="fa-lg"
                      [class]="
                        item.checked
                          ? 'fas fa-check-square text-secondary'
                          : 'far fa-square text-muted'
                      "
                    ></i>
                  </div>
                  <ng-container
                    [ngTemplateOutlet]="itemTemplate || defaultTemplate"
                    [ngTemplateOutletContext]="{ $implicit: item, index: iAll }"
                  >
                  </ng-container>
                </div>
              </button>
            }
          </mat-action-list>
        }
      </div>
    </mat-card>
  </div>
</div>
